export default {
  addOrganisationAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addOrganisation", payload)
      resolve()
    })
  }
}
